import type { SelectOption } from '@/components/ui/Select';

/**
 * Underrepresented-founder self-identification categories - values mirror
 * the backend's `common/constants/underrepresented-categories.ts` whitelist
 * exactly. Shared between the Startup Profile's Founding Team "Underrepresented
 * Founder" fields and the Investor Profile's "Underrepresented Founders" Part 2
 * (`docs/reference/data-fields.md`, client CSV 2026-07-16).
 */
export const UNDERREPRESENTED_CATEGORY_OPTIONS: SelectOption[] = [
  { value: 'black', label: 'Black' },
  { value: 'hispanic_latino', label: 'Hispanic or Latino' },
  { value: 'indigenous', label: 'Indigenous' },
  { value: 'veteran', label: 'Veteran' },
  { value: 'immigrant', label: 'Immigrant' },
  { value: 'other', label: 'Other' },
];
